import { render, staticRenderFns } from "./InNeedOfActionCard.vue?vue&type=template&id=1cb0a06a&"
import script from "./InNeedOfActionCard.vue?vue&type=script&lang=ts&"
export * from "./InNeedOfActionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports